import React, { useContext, useEffect, useRef, useState } from 'react';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import TaxDocumentFormContainer from './TaxDocumentFormContainer';
import { PaymentStatus } from '../../../app/models/PaymentStatus';
import { TaxDocumentPaymentDataForm } from '../../../app/models/TaxDocument';
import useTaxDocumentService from '../../../app/services/hooks/useTaxDocumentService';
import { Society } from '../../../app/models/Society';
import { Client } from '../../../app/models/Client';
import useClientService from '../../../app/services/hooks/useClientService';
import useNavigationPage from '../../../hooks/useNavigationPage';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    onSaved?: (data: any) => void;
    onCancel?: () => void;
    onError?: () => void;
}

const TaxDocumentCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [taxDocument, setTaxDocument] = useState<any>({});
    const { navigationPage } = useNavigationPage();
    const [societies, setSocieties] = useState<Society[]>([]);
    const [clients, setClients] = useState<Client[]>([]);
    const societyIdSelected = useRef<number | undefined>(0);
    const clientsFromToi = useRef<Client[]>([]);
    const [paymentStatuses, setPaymentStatuses] = useState<TaxDocumentPaymentDataForm[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    const {createTaxDocument, fetchingCreateTaxDocument} = useTaxDocumentService();
    const { storeTaxDocument, getPaymentStatusesByClientSociety, fetchingGetPaymentStatusesByClientSociety } = useTaxDocumentService();
    const { getClientsBySociety, fetchingGetClientBySociety } = useClientService();

    useEffect(() => {
        create();
    }, []);

    const create = () => {
        if (showLoading) showLoading('loading', 'Cargando datos...');
        createTaxDocument({
            onSuccess: (response: ServiceResponse) => {
                // setPaymentStatuses(response.data.payment_statuses);
                setSocieties(response.data.societies);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    // Fetch clients when society_id changes
    useEffect(() => {
        if (taxDocument.society_id && taxDocument.society_id !== societyIdSelected.current) {
            getClientsBySociety(taxDocument.society_id, {
                onSuccess: (response: ServiceResponse) => {
                    setClients(response.data.clients);
                    societyIdSelected.current = taxDocument.society_id;
    
                    // Type prev as TaxDocumentType
                    setTaxDocument ({
                        ...taxDocument,
                        client_id: 0, // Reset client selection
                    });
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                },
            });
        }
    }, [taxDocument.society_id]);


    useEffect(() => {
        if (taxDocument.society_id && taxDocument.client_id) {
            getPaymentStatusesByClientSociety(taxDocument.society_id, taxDocument.client_id, {
                onSuccess: (response: ServiceResponse) => {
                    setPaymentStatuses(response.data.payment_statuses);
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            });
        }
    }, [taxDocument.society_id, taxDocument.client_id]);

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando factura de venta...');
        storeTaxDocument(taxDocument, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.success(response.message, { autoClose: 2500 });
                const taxDocumentId = response.data?.tax_document_id;
                if (taxDocumentId) {
                    navigationPage(`/tax-documents/${taxDocumentId}/edit`); // Redirigir automáticamente
            }
                if (onSaved) {
                    onSaved(response.data);
            }
            
            },
            onError: (response: ServiceResponse) => {
                console.log('ñlasdñlkassdñlkañsldkñl')
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message,
                });
                toast.error(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingCreateTaxDocument ? (
        <div>Cargando...</div>
    ) : (
        <TaxDocumentFormContainer
            action={store}
            cancel={cancel}
            societies={societies}
            clients={clients}
            taxDocument={taxDocument}
            setTaxDocument={setTaxDocument}
            availableStatuses={paymentStatuses}
            errorFields={errorFields}
            updated={false}
            disabled={false}
            loadingClient={fetchingGetClientBySociety}
            loadingPaymentStatus={fetchingGetPaymentStatusesByClientSociety}
        />
    );
};

export default TaxDocumentCreate;
